import { type CSSProperties, useMemo } from 'react';
import DOMPurify from 'dompurify';

/**
 * Единственная точка вставки HTML в DOM (аудит 2026-07-14): DOMPurify
 * вырезает <script>, inline-обработчики (onerror/onclick) и
 * javascript:-ссылки. Контент у нас пишут свои редакторы, но правило
 * простое — сырой dangerouslySetInnerHTML в коде больше не используем,
 * только этот компонент.
 */
export function SafeHtml({
  html,
  className,
  style,
}: {
  html: string;
  className?: string;
  style?: CSSProperties;
}) {
  const clean = useMemo(
    () =>
      DOMPurify.sanitize(html, {
        USE_PROFILES: { html: true },
        // target/rel нужны ссылкам «открыть в новой вкладке» из редактора.
        ADD_ATTR: ['target', 'rel'],
      }),
    [html],
  );
  return <div className={className} style={style} dangerouslySetInnerHTML={{ __html: clean }} />;
}
